import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IDataSourceItem } from 'Modules/Studio/DataSources/redux/initialState';
import { TABLE_PAGE_LIMIT } from '../../../hooks/useFetchDataSourceTables.query';

export type TDataSourceListView = 'dataSources' | 'tables';

export type TTables = {
  searchTerm: string;
  pageLimit: number;
  pageNumber: number;
};
export interface IIngestionDataSourceListState {
  view: TDataSourceListView;
  selectedDataSource: IDataSourceItem | null;
  tables: TTables;
}

export const ingestionDataSourceListInitialState: IIngestionDataSourceListState = {
  view: 'dataSources',
  selectedDataSource: null,
  tables: {
    searchTerm: '',
    pageLimit: TABLE_PAGE_LIMIT,
    pageNumber: 1,
  },
};

export const IngestionDataSourceListReducer = {
  resetState: (state: IIngestionDataSourceListState) => {
    state.view = ingestionDataSourceListInitialState.view;
    state.selectedDataSource = ingestionDataSourceListInitialState.selectedDataSource;
    state.tables.searchTerm = ingestionDataSourceListInitialState.tables.searchTerm;
    state.tables.pageLimit = ingestionDataSourceListInitialState.tables.pageLimit;
    state.tables.pageNumber = ingestionDataSourceListInitialState.tables.pageNumber;
  },

  setView: (
    state: IIngestionDataSourceListState,
    action: PayloadAction<{ view: TDataSourceListView }>
  ) => {
    state.view = action.payload.view;
  },

  goToTableView: (
    state: IIngestionDataSourceListState,
    action: PayloadAction<{ selectedDataSource: IDataSourceItem }>
  ) => {
    state.view = 'tables';
    state.selectedDataSource = action.payload?.selectedDataSource || null;
  },

  goToDataSourceListView: (state: IIngestionDataSourceListState) => {
    state.view = 'dataSources';
    state.selectedDataSource = null;
    state.tables.searchTerm = ingestionDataSourceListInitialState.tables.searchTerm;
    state.tables.pageLimit = ingestionDataSourceListInitialState.tables.pageLimit;
    state.tables.pageNumber = ingestionDataSourceListInitialState.tables.pageNumber;
  },

  setTableSearchTerm: (
    state: IIngestionDataSourceListState,
    action: PayloadAction<{ searchTerm: string }>
  ) => {
    state.tables.searchTerm = action.payload.searchTerm || '';
    state.tables.pageNumber = 1;
  },

  setTablePageNumber: (
    state: IIngestionDataSourceListState,
    action: PayloadAction<{ pageNumber: number }>
  ) => {
    state.tables.pageNumber = action.payload.pageNumber || 1;
  },
};

const IngestionDataSourceListSlice = createSlice({
  name: 'ingestionDataSourceList',
  initialState: ingestionDataSourceListInitialState,
  reducers: IngestionDataSourceListReducer,
});

export const {
  resetState,
  setView,
  goToTableView,
  goToDataSourceListView,
  setTableSearchTerm,
  setTablePageNumber,
} = IngestionDataSourceListSlice.actions;

export default IngestionDataSourceListSlice.reducer;
